import { createBrowserRouter } from "react-router-dom";
import { lazy } from "react";
import Loadable from "../components/Loadable";
import AdminLayout from "../layout/AdminLayout";
import ProtectedRoute from "./ProtectedRoute";

const Dashboard = Loadable(lazy(() => import("../views/dashboard")));
const Connections = Loadable(lazy(() => import("../views/connections")));
const Subscriptions = Loadable(lazy(() => import("../views/subscriptions")));
const PromoCodes = Loadable(lazy(() => import("../views/promoCodes")));
const StripeProducts = Loadable(lazy(() => import("../views/stripeProducts")));
const UserDetail = Loadable(lazy(() => import("../views/userDetail")));
const UserDetailIndex = Loadable(lazy(() => import("../views/userDetail/UserDetailIndex")));
const Login = Loadable(lazy(() => import("../views/login")));
const Docs = Loadable(lazy(() => import("../views/docs")));
const EnvVars = Loadable(lazy(() => import("../views/envVars")));

const basename = (import.meta.env.BASE_URL || '/').replace(/\/$/, '') || '/';
const router = createBrowserRouter(
  [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/connections",
        element: <Connections />,
      },
      {
        path: "/subscriptions",
        element: <Subscriptions />,
      },
      {
        path: "/promo-codes",
        element: <PromoCodes />,
      },
      {
        path: "/stripe-products",
        element: <StripeProducts />,
      },
      {
        path: "/docs",
        element: <Docs />,
      },
      {
        path: "/env",
        element: <EnvVars />,
      },
      {
        path: "/users/:userId",
        element: <UserDetail />,
        children: [
          {
            index: true,
            element: <UserDetailIndex />,
          },
        ],
      },
    ],
  },
],
  { basename }
);

export default router;
